export { default } from './ModulVerifica';
